export const xxdObjectType = [
  { title: '海外大学', model: 'school' },
  { title: '海外高中', model: 'highschool' },
  { title: '国际学校', model: 'intschool' },
  { title: '方案', model: 'plan' },
  { title: '老师', model: 'consultant' },
];
